// Author YuJiaBei
// Date 2024-05-10 07:35:05

class EmMaMaintenanceSchedule {
constructor({
        id = null,
        name = '',
        emArchBasicDataCode = '',
        emArchToolKitId = '',
        periodicUnit = '',
        periodicValue = '',
        nextExecutionDate = '',
        mmscAuthor = '',
        mmscExecutor = '',
        mmscAccepter = '',
        suspensionState = '',
        mmscCategory = '',
        mmscContent = '',
        mmscPlanEndTime = '',
        mmscAttachment = '',
        remark = '',
        mmscAttachmentList = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.emArchBasicDataCode = emArchBasicDataCode;
    this.emArchToolKitId = emArchToolKitId;
    this.periodicUnit = periodicUnit;
    this.periodicValue = periodicValue;
    this.nextExecutionDate = nextExecutionDate;
    this.mmscAuthor = mmscAuthor;
    this.mmscExecutor = mmscExecutor;
    this.mmscAccepter = mmscAccepter;
    this.suspensionState = suspensionState;
    this.mmscCategory = mmscCategory;
    this.mmscContent = mmscContent;
    this.mmscPlanEndTime = mmscPlanEndTime;
    this.mmscAttachment = mmscAttachment;
    this.remark = remark;
    this.mmscAttachmentList = mmscAttachmentList;
}
}

function newEntity() {
return new EmMaMaintenanceSchedule();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'emArchBasicDataName',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'periodicUnit',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.periodicUnit',
        sortable: true,
        form: {
        type: 'scheduledPeriodicUnit',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'periodicValue',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.periodicValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'nextExecutionDate',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.nextExecutionDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscAuthor',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscAuthor',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscAuthorName',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscAuthorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscExecutor',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscExecutor',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscExecutorName',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscExecutorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscAccepter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscAccepter',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscAccepterName',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscAccepterName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'suspensionState',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.suspensionState',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscCategoryName',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscCategoryName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscContent',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscContent',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscPlanEndTime',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscPlanEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mmscAttachmentList',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.mmscAttachmentList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.grid.remark',
        sortable: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    nameFilter : '',
    emArchBasicDataCodeFilter : '',
    emArchToolKitIdFilter : '',
    periodicUnitFilter : '',
    periodicValueFilter : '',
    nextExecutionDateGeFilter : '',
    nextExecutionDateLeFilter : '',
    mmscAuthorFilter : '',
    mmscExecutorFilter : '',
    mmscAccepterFilter : '',
    suspensionStateFilter : '',
    mmscCategoryFilter : '',
    mmscContentFilter : '',
    mmscPlanEndTimeRteFilter : '',
    mmscPlanEndTimeLteFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'periodicUnitFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.periodicUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'periodicValueFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.periodicValue',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nextExecutionDateGeFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.nextExecutionDateGe',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nextExecutionDateLeFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.nextExecutionDateLe',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mmscAuthorFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.mmscAuthor',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'mmscExecutorFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.mmscExecutor',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'mmscAccepterFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.mmscAccepter',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'suspensionStateFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.suspensionState',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mmscCategoryFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.mmscCategory',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emMaMaintenanceCat'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'mmscContentFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.mmscContent',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mmscPlanEndTimeRteFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.mmscPlanEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mmscPlanEndTimeLteFilter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.filter.mmscPlanEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.emArchBasicDataCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'periodicUnit',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.periodicUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'scheduledPeriodicUnit',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'periodicValue',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.periodicValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nextExecutionDate',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.nextExecutionDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mmscExecutor',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.mmscExecutor',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'mmscAccepter',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.mmscAccepter',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'suspensionState',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.suspensionState',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mmscCategory',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.mmscCategory',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emMaMaintenanceCat'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'mmscContent',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.mmscContent',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mmscPlanEndTime',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.mmscPlanEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mmscAttachmentList',
        label: 'label.em.maintenance.emMaMaintenanceSchedule.entity.mmscAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'mmscAttachment'
                }
        }
]

export {EmMaMaintenanceSchedule, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
